import { Icon } from "@material-ui/core";
import { useMemo, useState } from "react";
import CustomDatePickerV2 from '@fuse/components/customDatePicker/DatePickerV2'
import { useDebounce } from "@fuse/hooks";
import dayjs from "dayjs";

export default function CustomFilter(props, header = '', gridRef = {}) {
const columnHeaderAndValueMap = (props.api.getColumnDefs() || []).reduce((acc, col) => {
  acc[col.field] = col.headerName;
  return acc;
}, {});

  // const [columnHeaderAndValueMap, setColumnHeaderAndValueMap] = useState({
  //   "contract_type_name": "Contract Type Name",
  //   "asset_tag": "Asset Tag", "name": "Asset Name",
  //   "user_name": "User",
  //   "status": "Status",
  //   "contract_number": "Contract Number"
  // })

  const [visibility, setVisibility] = useState(false);
  const [filterDate, setFilterDate] = useState({
    date: null,
    error: false
  });
  const [filterValue, setFilterValue] = useState(null);
  const colId = props.column.colDef.field;
  const headerName = props?.column.colDef.headerName || props?.column.colDef.field;

  function formatDate(inputDate) {
    const dateObj = new Date(inputDate);

    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
    const month = monthNames[dateObj.getMonth()];
    const day = (`0${dateObj.getDate()}`).slice(-2);
    const year = dateObj.getFullYear();

    const outputDate = `${month} ${day}, ${year}`;

    return outputDate;
  }

  const debounceFetch = useDebounce((event) => {
    handleChange(event)
  }, 1000)

   const isDateField = useMemo(
    () =>
      colId?.toLowerCase()?.includes("date") ||
      colId?.toLowerCase()?.includes("time"),
    [colId]
  );

  const handleChange = (e) => {
    // for activity
    if (props.column.colDef.field?.toLowerCase()?.includes('date')) {
      requestIdleCallback(() => {
        props.api.setFilterModel({
          ...props.api.getFilterModel(),
          [props.column.colDef.field]: {
            filterType: "text",
            type: "contains",
            filter: dayjs(e).format('YYYY-MM-DD')
          }
        });
        gridRef.current = {
          ...gridRef.current,
          filterModelArr: props.api.getFilterModel()
        }
      })
    } else if (props.column.colDef.field?.toLowerCase()?.includes('time')) {
      requestIdleCallback(() => {
        props.api.setFilterModel({
          ...props.api.getFilterModel(),
          [props.column.colDef.field]: {
            filterType: "text",
            type: "contains",
            filter: dayjs(e).format('YYYY-MM-DD')
          }
        });
        gridRef.current = {
          ...gridRef.current,
          filterModelArr: props.api.getFilterModel()
        }
      })
    } else {
      setFilterValue(e.target.value)
      requestIdleCallback(() => {
        props.api.setFilterModel({
          ...props.api.getFilterModel(),
          [props.column.colDef.field]: {
            filterType: "text",
            type: "contains",
            filter: e.target.value
          }
        });
        gridRef.current = {
          ...gridRef.current,
          filterModelArr: props.api.getFilterModel()
        }
      })
    }
  }

  // useEffect(()=>{
  //   const keyArr = Object.keys(gridRef?.current?.api?.getFilterModel() || {})
  //   if (keyArr.includes(header)) {
  //     setVisibility(true)
  //     setFilterValue(gridRef?.current?.api?.getFilterModel()[header]?.filter)
  //   }
  // }, [gridRef?.current?.api])

   const removeFilterForColumn = (colId) => {
    if (!gridRef.current) return;
    if (colId?.toLowerCase()?.includes('date') || colId?.toLowerCase()?.includes('time')) {
      setFilterDate({ date: null, error: null })
    }

    requestIdleCallback(() => {
      const currentFilterModel = props.api.getFilterModel();
      delete currentFilterModel[colId];
      props.api.setFilterModel(currentFilterModel);
      gridRef.current = {
        ...gridRef.current,
        filterModelArr: currentFilterModel
      }
    })
  }

  const applySort = (direction) => {
    const gridApi = gridRef.current?.api;
    if (!gridApi) return;
    gridRef.current?.api?.applyColumnState({
      defaultState: { sort: null },
      state: [
        { colId: props.column.colDef.field, sort: direction },
      ],
    });
    if (typeof gridApi?.refreshServerSide === 'function' || typeof gridApi?.refreshServerSideStore === 'function') {
      gridApi?.refreshServerSide?.({ purge: true }) || gridApi?.refreshServerSideStore?.({ purge: true });
    }
  };

  // ------------------- RENDER -------------------
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "100%",
        padding: "0 4px",
      }}
    >
      {/* ---------- Left: Header Text & Sort Icons ---------- */}
      {!visibility && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: 12,
            fontWeight: 600,
            color: "#1D2939",
            fontFamily: '"Inter", sans-serif',
          }}
        >
          <div
            className="sort_icon_holder"
            style={{
              display: "flex",
              // flexDirection: "column",
              marginRight: 4,
              cursor: "pointer",
              lineHeight: "10px",
            }}
          >
            <span className="icon_holder" style={{width: '10px' }}>
            <i
              className="ti ti-arrow-narrow-down"
              // style={{ fontSize: "1rem", marginBottom: 2 }}
              onClick={() => applySort("asc")}
              />
            </span>
            <span className="icon_holder" style={{width: '10px' }}>
            <i
              className="ti ti-arrow-narrow-up"
              // style={{ fontSize: "1rem" }}
              onClick={() => applySort("desc")}
              />
              </span>
          </div>
           <span style={{ paddingLeft: '6px' }}> {columnHeaderAndValueMap[colId]} </span>
        </div>
      )}

      {/* ---------- Right: Filter/Search ---------- */}
      <div  style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: "4px"
      }}>
        {visibility && !isDateField && (
          <input
            type="text"
            style={{
            flex: 1,
            width: "100%",
            minWidth: "60px",
            padding: "4px 6px",
            // border: "1px solid #E4E7EC",
            borderRadius: "6px",
            fontSize: 12,
            fontFamily: '"Inter", sans-serif',
            backgroundColor: 'transparent',
            outline: "none"
          }}
            placeholder="Search..."
            // value={filterValue}
            onChange={(e) => {
              setFilterValue(e.target.value);
              debounceFetch(e);
            }}
          />
        )}

        {visibility && isDateField && (
          <div style={{ flex: 1 }}>
            <CustomDatePickerV2
              state={filterDate}
              setState={setFilterDate}
              label=""
              required={false}
              onChangeFromParent={(e) => debounceFetch(e)}
               // style={{ flex: 1 }}
            />
          </div>
        )}
              </div>

        {/* Toggle Button */}
        {!visibility ? (
          <Icon
            onClick={() => setVisibility(true)}
            style={{ fontSize: "1.8rem", color: "#98A2B3", cursor: "pointer" }}
          >
            search
          </Icon>
        ) : (
          <Icon
            onClick={() => {
              setVisibility(false);
              removeFilterForColumn(colId);
            }}
            style={{ fontSize: "1.8rem", color: "#98A2B3", cursor: "pointer", marginTop: '3px' }}
          >
            close
          </Icon>
        )}
    </div>
  )
};